module.exports = __webpack_public_path__ + "img/lestnica_vneshnyaya_ulichnaya_mirror.ba5f1beb.svg";